export const INVENTORY_INCREASE_STATUS = {
  AMOUNT: "amount",
  PAYMENT: "prepayment",
  METHOD: "method",
  RECEIPT: "receipt",
};

export const handlePageTitle = ({ currentStage, translate }) => {
  switch (currentStage) {
    case INVENTORY_INCREASE_STATUS.AMOUNT:
      return translate("pma-inventory-increase.amount");
    case INVENTORY_INCREASE_STATUS.PAYMENT:
      return translate("pma-inventory-increase.prepayment");
    case INVENTORY_INCREASE_STATUS.METHOD:
      return translate("pma-inventory-increase.payment-method");
    case INVENTORY_INCREASE_STATUS.RECEIPT:
      return translate("pma-inventory-increase.receipt");
    default:
      break;
  }
};
